import { StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { RequestState } from 'src/models/RequestState';
import { ScaleLoader } from 'react-spinners';
import { AuthorPublications } from 'src/components/AuthorPublications';
import { TabBar, CPOption } from 'src/components/TabBar';
import { AuthorExpenditures } from 'src/components/AuthorExpenditures';
import { AppStore, appStore } from 'src/mobx/AppStore';
import { TabOptions } from 'src/mobx/FacultyPageStore';
import axios from "axios";
import { AuthorPageData } from '../mobx/FacultyPageStore';
import { observer, inject } from 'mobx-react';
import { Api } from 'src/core/api';
import { JsonConvert } from 'json2typescript';
import { AuthorPublicationCombined, BasicDetails } from 'src/models/AuthorPublicationsCombined';
import { AuthorCombined } from "src/components/AuthorCombined";
import { AuthorAwards } from "src/components/AuthorAwards";
import { AuthorProposals } from '../components/AuthorProposals';
import { CPGenericDialog } from 'src/components/dialogs/CPGenericDialog';



interface IAuthorPageProps {
    author_id: string,
    history: any,
    section: number
}


class FacultyPageState {
    public readonly requestState: RequestState = RequestState.NOT_ASKED;
    public readonly data: BasicDetails = new BasicDetails();
    public readonly error: string = "";
    public readonly isGenericDialogOpen: boolean = false;
}

@observer
export class FacultyPage extends React.Component<IAuthorPageProps,FacultyPageState> {
    
    constructor(props : IAuthorPageProps) {
        super(props);
        this.state = new FacultyPageState();
    }

    public async componentDidMount(){
        this.setState({...this.state, requestState: RequestState.LOADING});
        const url = `${Api.getEndPoint()}/basic-details/${this.props.author_id}`;
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserialize(res.data, BasicDetails);
                    const newState = {...this.state, requestState: RequestState.SUCCESS, data: data}
                    this.setState(newState)
                }catch(error) {
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                    this.setState(newState)
                }
            }else{
                const error = res.statusText + ":" + res.data
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            }    
        }).catch((err)=>{
            const error = err.toString();
            const newState = {...this.state, requestState: RequestState.ERROR, error: error}
            this.setState(newState)
        });   
    }


    public render() {
        let content;
        if(this.state.requestState === RequestState.SUCCESS){
            let tabContent;
            if(this.props.section === TabOptions.PUBLICATIONS){
                tabContent = (<AuthorPublications author_id={this.props.author_id}
                                                    first_name={this.state.data.first_name}
                                                    last_name={this.state.data.last_name}  />)
            }else if(this.props.section === TabOptions.EXPENDITURES){
                tabContent = (<AuthorExpenditures author_id={this.props.author_id}
                                                first_name={this.state.data.first_name}
                                                last_name={this.state.data.last_name}
                                                    />)
            }else if(this.props.section === TabOptions.COMBINED) {
                tabContent = (<AuthorCombined author_id={this.props.author_id}/>)
            }else if(this.props.section === TabOptions.AWARDS) {
                tabContent = (<AuthorAwards author_id={this.props.author_id}
                    first_name={this.state.data.first_name}
                    last_name={this.state.data.last_name}
                />)
            }else if(this.props.section === TabOptions.PROPOSALS) {
                tabContent = (<AuthorProposals author_id={this.props.author_id}
                                                first_name={this.state.data.first_name}
                                                last_name={this.state.data.last_name} />)
            }
            else{
                tabContent = (<div>
    
                </div>)
            }

            content = (<div id="content" className={css(styles.content)} >
                            
                <div id="author_info_container" className={css(styles.author_info_container)}  >
                    <React.Fragment>
                        <div id="author_name" className={css(styles.author_name)} >
                            {this.state.data.last_name}, {this.state.data.first_name}
                        </div>
                        <div id="univ_info" className={css(styles.university_info)}>
                            {this.state.data.affiliation.top_level}
                        </div>
                    </React.Fragment>
                </div>

                <div className={css(styles.tabContainer)}>
                    <TabBar tabs={["Proposals","Awards","Expenditures","Combined","Publications"]}
                            activeIndex={this.props.section}
                            onTabClick={this.onPageSelected}
                            onCPOptionSelected={this.onCPOptionSelected} 
                            />
                </div>
                
                {tabContent}
                                                
            </div>);
        }else{
            content = (<div id="content" className={css(styles.content_empty)} >
                <div className={css(styles.loader)} >
                    <ScaleLoader
                        height={50}
                        width={5}
                        color={'#808080ff'}
                        loading={true}
                        />
                </div>                                      
            </div>);
        } 

        return (
            <React.Fragment>
                <div id="div_page" className={css(styles.page)} >
                     {content}                                     
                </div>
                {this.buildGenericDialog()}
            </React.Fragment>
            
        ); 
        
    }

    private onPageSelected = (value: number) => {
        appStore.facultyPageStore.setSelectedTab(value)
        this.props.history.push(`/faculty/${this.props.author_id}?section=${value}`)
    }

    private onCPOptionSelected = (option: CPOption) => {
        if(option === CPOption.GENERIC){
            this.setState({...this.state, isGenericDialogOpen: true})
        }
    }

    private buildGenericDialog = () => {
        return <CPGenericDialog  author_id={this.props.author_id}
                                 first_name={this.state.data.first_name}
                                 last_name={this.state.data.last_name}
                                 isOpen={this.state.isGenericDialogOpen}
                                 onClose={this.onCPGenericDialogClose}/>
    }

    private onCPGenericDialogClose = () => {
        this.setState({...this.state, isGenericDialogOpen: false})
    }
    

}

const styles = StyleSheet.create({
    
    page: {
        height: "100%",
        paddingLeft: 20,
        paddingRight: 20
    },

    content: {
        display: "flex",
        minHeight: "70vh",
        flexDirection: "column",
        flexGrow: 1,
    },

    content_empty: {
        display: "grid",
        alignItems: "center",
        alignContent: "center"
    },
    
    author_info_container: {
        marginTop: 30,
        marginLeft: 10
    },
       
    author_name: {
        fontSize: 40,
        color: "#676767ff"
    },

    university_info: {
        fontSize: 22,
        marginTop: 5,
        color: "#676767ff"
    },

    department_info: {
        fontSize: 16,
        marginTop: 5,
        color: "#676767ff"
    },

    author_id: {
        fontSize: 16,
        marginTop: 2,
        color: "#676767ff"
    },

    tabContainer: {
        marginTop: 20,
    },

    loader: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)"
    }

});




// WEBPACK FOOTER //
// ./src/pages/FacultyPage.tsx